import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME } from './constants';

export const PrijemkaNAME = <const>'NdPrijemka';

class NdPrijemkaPolozkyProvider extends BaseApi {
	updateLeftToDeliverCount(mioId: number, leftToDeliverCount: number) {
		return this.fetch(`/${MODULE_API}/${PrijemkaNAME}/UpdateleftToDeliverCount`, { mioId, leftToDeliverCount });
	}
}

export const apiProvider = new NdPrijemkaPolozkyProvider(MODULE_API, NAME);
